/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Picker_Race_NoticeInputs */

const en_picker_race_notice = /** @type {(inputs: Picker_Race_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Those dates were just taken. Please pick another range.`)
};

/**
* | output |
* | --- |
* | "Those dates were just taken. Please pick another range." |
*
* @param {Picker_Race_NoticeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const picker_race_notice = /** @type {((inputs?: Picker_Race_NoticeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_Race_NoticeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_picker_race_notice(inputs)
});